export const reportDigitalInventoryTypes = {
  SET_REPORT_DIGITAL_INVENTORY_FILTERS: 'SET_REPORT_DIGITAL_INVENTORY_FILTERS',
  RESTORE_INITIAL: 'RESTORE_INITIAL'
};